<template>
  <el-dialog
    title="数据统计"
    :visible="true"
    :before-close="onCloseDialog"
    width="1500px"
  >
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-date-picker
            v-model="form.create_time"
            type="date"
            placeholder="选择日期"
            @change="fetchData"
          >
          </el-date-picker>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 50px;line-height:30px;padding: 0 25px;display: flex; align-items:center;"
        >
          &nbsp;&nbsp;&nbsp;&nbsp;未发货订单：{{
            resData.wait_shipping
          }}
          &nbsp;&nbsp;&nbsp;&nbsp;未配货订单：{{
            resData.wait_allot
          }}
          &nbsp;&nbsp;&nbsp;&nbsp;已上架商品数量：{{ resData.upshelf_num }}
        </div>
        <div style="margin-bottom: 0;">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="loading"
            height="400"
            :data="resData.table_data"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="label"
              label="仓区"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="no_full_allot_num"
              label="未配齐波次"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="full_allot_num"
              label="已配齐未锁定波次"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="full_allot_goods_num"
              label="已配齐未锁定波次商品"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="today_full_allot_num"
              label="已今日配齐未锁定波次"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="today_full_allot_goods_num"
              label="已今日配齐未锁定波次商品"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="lock_num"
              label="已锁定波次"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="lock_goods_num"
              label="已锁定波次商品"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="task_num"
              label="待拣货任务"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wave_num"
              label="待拣货波次"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_num"
              label="待拣货商品"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      resData: {},
      loading: false,
      url: "/erp/WavePicking/Statistics",
      form: {},
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http
        .post(this.url, this.form)
        .then(result => {
          this.loading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          this.$set(this, "resData", result.data.data);
        })
        .catch(err => {
          this.loading = false;
          this.onCloseDialog();
          return this.$message.error("数据获取失败");
        });
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/wavepicking/components/Statistics.vue